export const graphCmsProjectUrls = {
  MY: 'https://api-ap-northeast-1.graphcms.com/v2/ckr3is91609ht01zb8kxl7fyx/master',
  HK: 'https://api-ap-northeast-1.graphcms.com/v2/ckr3iqt5v09h401y16d4w50at/master',
  TW: 'https://api-ap-northeast-1.graphcms.com/v2/ckr3in1cy099w01y1ft55dri7/master',
  SG: 'https://api-ap-northeast-1.graphcms.com/v2/ckoay27x667jn01z01qow2scg/master'
}
